import React, { useState } from "react";
import { Subheading } from "../../../subComponents/subHeading";
import { Text } from "../../../subComponents/text";
import { Img } from "../../../subComponents/img";
import { baseurl } from "../../../CommonComponents/baseurl";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Link } from "react-router-dom";

const GetInTouchSection = () => {
  const [customer_name, setCustomerName] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [required_service, setRequiredService] = useState("uPVC");
  const [otherdescription, setOtherDescription] = useState("");

  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const validateForm = () => {
    if (!customer_name) {
      setError("Name is required");
      handleClick();
      return false;
    }
    if (!phone_number) {
      setError("Phone number is required");
      handleClick();
      return false;
    }
    // if (!email) {
    //   setError("Email is required");
    //   handleClick();
    //   return false;
    // }
    if (required_service === "other" && !otherdescription) {
      setError("Please specify the service");
      handleClick();
      return false;
    }
    setError(""); // Clear any previous error
    return true;
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    // Allow only numeric values
    if (/^\d*$/.test(value)) {
      if (value.length <= 15) {
        setPhoneNumber(value);
        setPhoneNumberError("");
      } else {
        setPhoneNumberError("Cannot enter more than 15 characters");
        handleClick();
      }
    } else {
      setPhoneNumberError("Only numeric values are allowed");
      handleClick();
    }
  };

  const formSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      const response = await fetch(`${baseurl}/api/contact-us`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_name,
          phone_number,
          email,
          required_service,
          otherdescription,
        }),
      });

      const data = await response.json();
      if (data.success === "1") {
        setSuccessMessage(data.message);
        clearForm();
        handleClick();
        // handleOpen2();
      } else {
        console.error("Failed to submit data:", data.message);
        setError(data.message);
        console.log(data.message);
        handleClick();
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      setError("An error occurred. Please try again.");
      handleClick();
    }
  };

  const clearForm = () => {
    setCustomerName("");
    setPhoneNumber("");
    setEmail("");
    setRequiredService("uPVC");
    setOtherDescription("");
  };

  return (
    <>
      <section className="getin_touch_section">
        <div className="getin_touch_container" id="quiery-form">
          <div className="getin_touch_left_container">
            <Subheading orangetext={"Get In"} title={" Touch"} />
            <Text
              style={{ marginTop: "1rem" }}
              text={"If you have any query, feel free to ask for details."}
            />
            <br />
            <div className="contact_info">
              <div
                className="address_container"
                style={{ backgroundColor: "#fff", padding: "0.675rem 1.2rem" }}
              >
                <div
                  className="address_image"
                  style={{ maxWidth: "2rem", maxHeight: "2rem" }}
                >
                  <Img
                    src={"/assets/images/Contactus/phone.png"}
                    alt={"phone.png"}
                  />
                </div>
                <div>
                  <Subheading
                    style={{
                      fontSize: "1rem",
                      color: "#c82e21",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                    title={"Phone Number"}
                  />
                  <Text
                    text={"+91 9996970583"}
                    style={{ marginBottom: "0", marginTop: "0.3rem" }}
                  />
                </div>
              </div>
                            <div
                className="address_container"
                style={{ backgroundColor: "#fff", padding: "0.675rem 1.2rem" }}
              >
                <div
                  className="address_image"
                  style={{ maxWidth: "2rem", maxHeight: "2rem" }}
                >
                  <Img
                    src={"/assets/images/Contactus/phone.png"}
                    alt={"phone.png"}
                  />
                </div>
                <div>
                  <Subheading
                    style={{
                      fontSize: "1rem",
                      color: "#c82e21",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                    title={"Phone Number"}
                  />
                  <Text
                    text={"+91 9996970681"}
                    style={{ marginBottom: "0", marginTop: "0.3rem" }}
                  />
                </div>
              </div>
              <div
                className="address_container"
                style={{ backgroundColor: "#fff", padding: "0.675rem 1.2rem" }}
              >
                <div
                  className="address_image"
                  style={{ maxWidth: "2rem", maxHeight: "2rem" }}
                >
                  <Img
                    src={"/assets/images/Contactus/email.png"}
                    alt={"email.png"}
                  />
                </div>
                <div>
                  <Subheading
                    style={{
                      fontSize: "1rem",
                      color: "#c82e21",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                    title={"E-mail"}
                  />
                  <Text
                    text={"marketing@tubeflexindia.com"}
                    style={{ marginBottom: "0", marginTop: "0.3rem" }}
                  />
                </div>
              </div>
              <Link to="https://maps.app.goo.gl/siJGiLZjFTBG3qcw6" style={{textDecoration:"none", color:"black"}} target="_blank" >
              <div
                className="address_container"
                style={{ backgroundColor: "#fff", padding: "0.675rem 1.2rem" }}
              >
                <div className="address_image">
                  {/* <img
                    src={"/assets/images/Contactus/location.png"}
                    alt={"location.png"}
                    height={"100%"}l
                  /> */}
                  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} style={{fontWeight:"400"}} viewBox="0 0 100 100"><path fill="currentColor" d="M50.001 0C33.65 0 20.25 13.36 20.25 29.666c0 6.318 2.018 12.19 5.433 17.016L46.37 82.445c2.897 3.785 4.823 3.066 7.232-.2l22.818-38.83c.46-.834.822-1.722 1.137-2.629a29.3 29.3 0 0 0 2.192-11.12C79.75 13.36 66.354 0 50.001 0m0 13.9c8.806 0 15.808 6.986 15.808 15.766S58.807 45.43 50.001 45.43c-8.805 0-15.81-6.982-15.81-15.763S41.196 13.901 50 13.901"></path><path fill="currentColor" d="m68.913 48.908l-.048.126l.042-.115zM34.006 69.057C19.88 71.053 10 75.828 10 82.857C10 92.325 26.508 100 50 100s40-7.675 40-17.143c0-7.029-9.879-11.804-24.004-13.8l-1.957 3.332C74.685 73.866 82 76.97 82 80.572c0 5.05-14.327 9.143-32 9.143s-32-4.093-32-9.143c-.001-3.59 7.266-6.691 17.945-8.174z" color="currentColor"></path></svg>
                </div>
                <div>
                  <Subheading
                    style={{
                      fontSize: "1rem",
                      color: "#c82e21",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                    title="Office & Work"
                  />
                  <Text
                    style={{ marginBottom: "0", marginTop: "0.3rem" }}
                    // highlightText="Head Office:"
                    text={`Plot No. 27, Vill. Badodli jajru, Bypass Road
121004. ballabhgarh (Faridabad) HR `}
                  />
                </div>
              </div>
              </Link>
              {/* <div
                className="address_container"
                style={{ backgroundColor: "#fff", padding: "0.675rem 1.2rem" }}
              >
                <div className="address_image">
                  <img
                    src={"/assets/images/Contactus/location.png"}
                    alt={"location.png"}
                    height={"100%"}
                  />
                </div>
                <div>
                  <Subheading
                    style={{
                      fontSize: "1rem",
                      color: "#c82e21",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                    title="Manufacturing Unit"
                  />
                  <Text
                    style={{ marginBottom: "0", marginTop: "0.3rem" }}
                    // highlightText="Head Office:"
                    text={`Plot No. 15, Near Asharam Bapu Ashram, Pali Road, Bhakri, Faridabad – 121004`}
                  />
                </div>
              </div> */}
              <div
                className="address_container"
                style={{
                  backgroundColor: "#fff",
                  padding: "0.675rem 1.2rem",
                  gap: "1px",
                }}
              >
                <div className="address_image"></div>
                <div>
                  <Subheading
                    title={"OUR Supports"}
                    style={{
                      fontSize: "1rem",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  />
                </div>
              </div>

              {/* <div style={{ backgroundColor:'#fff',   padding:'0.675rem 1.2rem'}} >
              <Subheading title={"OUR SHOWROOMS"} style={{fontSize: "1rem", textTransform:"uppercase",textAlign:"start"}} />
              </div> */}

              <div
                className="address_container"
                style={{ backgroundColor: "#fff", padding: "0.675rem 1.2rem" }}
              >
                {/* <div className="address_image">
                  <img
                    src={"/assets/images/Contactus/location.png"}
                    alt={"location.png"}
                    height={"100%"}
                  />
                </div> */}
                <div>
                  {/* <Subheading
                    style={{ fontSize: "1rem", color: "#c82e21" }}
                    title="FARIDABAD"
                  /> */}

                  <Text
                    style={{ marginBottom: "0", marginTop: "0.3rem" }}
                    // highlightText="Rajasthan:"
                    text={<>We are always open to discussing your unique requirements, enhancing your vehicle’s performance, and solving complex fluid transmission challenges. Our team works closely with you to understand operating conditions, efficiency goals, and reliability expectations. From consultation and analysis to tailored solutions and ongoing support, we focus on delivering measurable results. Whether you need improved durability, smoother power transfer, reduced losses, or optimized system design, we bring expertise, precision, and practical insight. With a commitment to quality, innovation, and long-term partnerships, we help you achieve dependable performance, increased efficiency, and confidence in every application across diverse industries and operating environments worldwide.</>}
                  />
                </div>
              </div>
{/* 
              <div
                className="address_container"
                style={{ backgroundColor: "#fff", padding: "0.675rem 1.2rem" }}
              >
                <div className="address_image">
                  <img
                    src={"/assets/images/Contactus/location.png"}
                    alt={"location.png"}
                    height={"100%"}
                  />
                </div>
                <div>
                  <Subheading
                    style={{ fontSize: "1rem", color: "#c82e21" }}
                    title="JAIPUR"
                  />

                  <Text
                    style={{ marginBottom: "0", marginTop: "0.3rem" }}
                    // highlightText="Rajasthan:"
                    text={`Shop No. 226,227, New Aatish Market, Gopalpura Bypass, Jaipur, Rajasthan - 302019`}
                  />
                </div>
              </div>

              <div
                className="address_container"
                style={{
                  backgroundColor: "#fff",
                  padding: "0.675rem 1.2rem",
                  gap: "2px",
                }}
              >
                <div className="address_image">
                  <img
                    src={"/assets/images/Contactus/location.png"}
                    alt={"location.png"}
                    height={"100%"}
                  />
                </div>
                <div>
                  <Subheading
                    style={{ fontSize: "1rem", color: "#c82e21" }}
                    title="KISHANGARH"
                  />

                  <Text
                    style={{ marginBottom: "0", marginTop: "0.3rem" }}
                    // highlightText="Rajasthan:"
                    text={`Katla Bazar Madanganj, Kishangarh, Rajasthan - 305801`}
                  />
                </div>
              </div> */}
            </div>
          </div>

          <div className="getin_touch_right_container">
            <div className="innergetin_touch_right_container shadow">
              <Text
                style={{  fontSize: "1.3rem",textAlign:"center" }}
                text={"Tell us about your project"}
              />
              <div className="form_input_feild_container">
                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0" }}>Name</p>
                  </div>
                  <div className="input_feild">
                    <input
                      className="contact_form_input_feild"
                      type="text"
                      placeholder="Enter your name"
                      maxLength={35}
                      value={customer_name}
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0" }}>
                      Phone Number
                    </p>
                  </div>
                  <div className="input_feild">
                    <input
                      className="contact_form_input_feild"
                      type="text"
                      placeholder="Enter your phone number"
                      maxLength={13}
                      value={phone_number}
                      onChange={handlePhoneNumberChange}
                    />
                  </div>
                </div>
                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0" }}>
                      I’m looking for
                    </p>
                  </div>
                  <div className="input_feild">
                    <select
                      name="requiredService"
                      id="requiredService"
                      required
                      value={required_service}
                      onChange={(e) => setRequiredService(e.target.value)}
                    >
                      <option value="Metal Tubes">Metal Tubes</option>
                      <option value="Nylon Tube Assemblies">
                       Nylon Tube Assemblies
                      </option>
                      <option value="Manufacturing">
                        Manufacturing
                      </option>
                      <option value="other">other</option>
                    </select>
                  </div>
                </div>

                {required_service === "other" ? (
                  <div className="pricing_container">
                    <div className="input_feild_title">
                      <p style={{ marginBottom: "0" }}></p>
                    </div>
                    <div className="input_feild">
                      <input
                        className="contact_form_input_feild"
                        type="text"
                        placeholder="Please specify"
                        maxLength={50}
                        value={otherdescription}
                        onChange={(e) => setOtherDescription(e.target.value)}
                      />
                    </div>
                  </div>
                ) : null}

                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0"}}>Email ID</p>
                  </div>
                  <div className="input_feild">
                    <input
                      type="email"
                      className="contact_form_input_feild"
                      placeholder="Enter your email"
                      maxLength={70}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <button className="form_btn" onClick={formSubmit} style={{marginTop:"1rem"}}>
                  Submit
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 15 15"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      d="m13.5 7.5l-4-4m4 4l-4 4m4-4H1"
                    />
                  </svg>
                </button>

                <Snackbar
                  open={open}
                  autoHideDuration={3000}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <Alert
                    onClose={handleClose}
                    severity={error ? "error" : "success"}
                  >
                    {error || successMessage || phoneNumberError}
                  </Alert>
                </Snackbar>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export { GetInTouchSection };
